<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  buckets: { type: Array, default: () => [] },
  activeBucket: { type: String, default: '' },
  ariaLabel: { type: String, required: true },
  tabIdFor: { type: Function, required: true },
  panelIdFor: { type: Function, required: true },
});

const emit = defineEmits(['select', 'keydown']);
</script>

<template>
  <div class="border-b border-lais-border px-4 sm:px-6 lg:px-10">
    <div
      class="flex items-center gap-6 overflow-x-auto no-scrollbar"
      role="tablist"
      :aria-label="ariaLabel"
    >
      <button
        v-for="(bucket, index) in buckets"
        :id="tabIdFor(bucket.value)"
        :key="bucket.value"
        type="button"
        role="tab"
        :aria-selected="activeBucket === bucket.value ? 'true' : 'false'"
        :aria-controls="panelIdFor(bucket.value)"
        :tabindex="activeBucket === bucket.value ? 0 : -1"
        class="relative py-3 text-[14px] font-semibold transition-colors whitespace-nowrap"
        :class="
          activeBucket === bucket.value
            ? 'text-lais-primary'
            : 'text-lais-text-muted hover:text-lais-text-body'
        "
        @click="emit('select', bucket.value)"
        @keydown="emit('keydown', $event, index)"
      >
        {{ bucket.label }}
        <span
          v-if="activeBucket === bucket.value"
          class="absolute bottom-0 left-0 right-0 h-[3px] rounded-t bg-lais-primary"
        />
      </button>
    </div>
  </div>
</template>
